export default __webpack_public_path__ + "static/media/orders.20df753f.svg";